// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_MyImage_hyperlink__l5KVQ"};